import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

interface IRullerOnIcon extends SvgIconProps {
  iconColor?: string;
}

function RullerOnIcon({ iconColor = "#FFFFFF", ...props }: IRullerOnIcon) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="RullerOnIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="24px" height="24px" viewBox="0 0 24 24"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 24 24"
      }} xmlSpace="preserve">
      <path fill={iconColor} d="M1.271,17.184V6.816h21.458v10.367H1.271z M3.28,15.174H20.72V8.826h-3.014v3.335h-2.009V8.826h-2.692
	v3.335h-2.009V8.826H8.303v3.335H6.294V8.826H3.28V15.174z M6.294,12.161h2.009H6.294z M10.995,12.161h2.009H10.995z
		M15.697,12.161h2.009H15.697z"/>
    </svg>
  </SvgIcon>
}

export default RullerOnIcon;
